module.exports = __webpack_public_path__ + "img/download-windows-app-btn.c438fa72.webp";